<template>
  <div class="trainer-create">
    <weui-group>
      <weui-input label="称呼" placehold="请输入会员的称呼" v-model="name" />
    </weui-group>
    <weui-button-area>
      <weui-button type="primary" :disabled="!name" @click="save(true)">提交并绑定其微信</weui-button>
      <weui-button type="default" :disabled="!name" @click="save(false)">提交并返回</weui-button>
    </weui-button-area>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { WeuiGroup, WeuiInput, WeuiButtonArea, WeuiButton } from '@/components/weui';
import { POST_TRAINER } from '@/store/trainer/types';
import { ROUTE_TRAINER_VIEW } from '@/router/names';

const { mapState, mapActions } = createNamespacedHelpers('trainer');

export default {
    data() {
        return {
            name: null,
        };
    },
    computed: {
        ...mapState([
            'created',
        ]),
    },
    methods: {
        ...mapActions({
            postTrainer: POST_TRAINER,
        }),
        async save(view) {
            if (!this.name) {
                return;
            }

            await this.postTrainer({
                trainer: {
                    name: this.name,
                },
            });

            if (view) {
                this.$router.replace({
                    name: ROUTE_TRAINER_VIEW,
                    params: {
                        id: this.created.id,
                    },
                });
            } else {
                this.$router.go(-1);
            }
        },
    },
    components: {
        WeuiGroup,
        WeuiInput,
        WeuiButtonArea,
        WeuiButton,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/trainer/Create.vue